import { createAction } from '@reduxjs/toolkit';

const getAvailableMediaDevices = createAction('MEDIA_DEVICE_MENU_GET_AVAILABLE_MEDIA_DEVICES');
const setAvailableMediaDevices = createAction<MediaDeviceInfo[]>('MEDIA_DEVICE_MENU_SET_AVAILABLE_MEDIA_DEVICES');
const setSelectedMediaDevice = createAction<MediaDeviceInfo>('MEDIA_DEVICE_MENU_SET_SELECTED_MEDIA_DEVICE');
const selectMediaDeviceWithId = createAction<string>('MEDIA_DEVICE_MENU_SELECT_MEDIA_DEVICE_WITH_ID');

export default {
  getAvailableMediaDevices,
  setAvailableMediaDevices,
  setSelectedMediaDevice,
  selectMediaDeviceWithId
};
